import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const TransferIcon = (props: IconProps) => {
    return (
		<Icon {...props}>
			<svg viewBox="0 -960 960 960" >
				<g fill="currentColor">
                    <path d="M271-120 80-311l192-192 42 42-120 120h646v60H194l119 119-42 42Zm418-337-42-42 119-119H120v-60h646L646-798l42-42 192 192-191 191Z"/>
				</g>
			</svg>
		</Icon>
    )
}

export default TransferIcon;